import { faInfo } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Modal } from "antd";
import classNames from "classnames";
import styles from "./styles.module.scss";
import PropTypes from 'prop-types';

const CardTable = ({ children, className = "" }) => {
  return <div className={`${styles.cardTable} card-table ${className}`}>{children}</div>;
};
CardTable.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

CardTable.Header = ({ children }) => (
  <div className={styles.header}>{children}</div>
);
CardTable.Header.displayName = "CardTable.Header";
CardTable.Header.propTypes = {
  children: PropTypes.node.isRequired
};

CardTable.SubHeader = ({ children, infoContent }) => (
  <div className={styles.subheader}>
    <div>{infoContent && <CardInfo content={infoContent} size="small" />}</div>
    <div>{children}</div>
  </div>
);
CardTable.SubHeader.displayName = "CardTable.SubHeader";
CardTable.SubHeader.propTypes = {
  children: PropTypes.node.isRequired,
  infoContent: PropTypes.node
};

export const CardInfo = ({ content, noStyle = false, size = undefined, style = {} }) => {
  const modal = () =>
    Modal.info({
      title: "Informatie",
      content,
      className: "defaultModal",
      icon: false,
      width: 800,
    });

  return (
    <Button
      type="primary"
      style={style}
      className={classNames(styles.infoButton, size === 'small' && styles.small, !noStyle && styles.infoIcon)}
      shape="circle"
      onClick={modal}
      tabIndex={-1}
    >
      <FontAwesomeIcon icon={faInfo} />
    </Button>
  );
};
CardInfo.propTypes = {
  content: PropTypes.node.isRequired,
  noStyle: PropTypes.bool,
  size: PropTypes.oneOf(['small']),
  style: PropTypes.object
};

/**
 * @param {any} children
 * @param {any} infoContent
 * @returns
 */
const CardTableHeaderTitle = ({ children, infoContent = undefined }) => {
  return (
    <div className={styles.titleWrapper}>
      {infoContent && <CardInfo content={infoContent} size="small" />}
      <div className={styles.title}>{children}</div>
    </div>
  );
};
CardTableHeaderTitle.displayName = "CardTable.Header.Title";
CardTableHeaderTitle.propTypes = {
  children: PropTypes.node.isRequired,
  infoContent: PropTypes.node
};

CardTable.Header.Title = CardTableHeaderTitle;

const ColumnTitles = ({ children }) => (
  <div className={styles.columnTitles}>{children}</div>
);
ColumnTitles.propTypes = {
  children: PropTypes.node.isRequired
}

const ColumnUnits = ({ children }) => (
  <div className={styles.columnUnits}>{children}</div>
);
ColumnUnits.propTypes = {
  children: PropTypes.node.isRequired
}
export const CARD_TABLE_COLUMN_UNIT_HEIGHT = 15.7;
const ColumnUnit = ({ inline = false, children }) => {
  return (
    <div className={[styles.columnUnits, inline && styles.inline].join(" ")}>
      {children}
    </div>
  );
};
ColumnUnit.propTypes = {
  inline: PropTypes.bool,
  children: PropTypes.node.isRequired
};

CardTable.Body = ({ children, scrollable = false, className = "" }) => {
  const body = classNames([styles.body, className, scrollable && styles.scrollable]);
  return <div className={body}>{children}</div>;
};
CardTable.Body.displayName = "CardTable.Body";
CardTable.Body.propTypes = {
  children: PropTypes.node.isRequired,
  scrollable: PropTypes.bool,
  className: PropTypes.string
}

CardTable.TotalRow = ({ children }) => (
  <div className={styles.totalRow}>{children}</div>
);
CardTable.TotalRow.displayName = "CardTable.TotalRow";
CardTable.TotalRow.propTypes = {
  children: PropTypes.node.isRequired
};

CardTable.NumberField = ({ value, style = {} }) => (
  <div style={style} className={styles.numberField}>
    {value}
  </div>
);
CardTable.NumberField.displayName = "CardTable.NumberField";
CardTable.NumberField.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  style: PropTypes.object
};

CardTable.Info = ({ content }) => {
  const modal = () =>
    Modal.info({ title: "Info", content, icon: false, width: 600 });

  return (
    <Button
      type="primary"
      className={[styles.infoIcon, styles.small, styles.absolute].join(" ")}
      shape="circle"
      onClick={modal}
      tabIndex={-1}
    >
      <FontAwesomeIcon icon={faInfo} />
    </Button>
  );
};
CardTable.Info.displayName = "CardTable.Info";
CardTable.Info.propTypes = {
  content: PropTypes.node.isRequired
};

CardTable.Header.ColumnTitles = ColumnTitles;
CardTable.SubHeader.ColumnTitles = ColumnTitles;
CardTable.Header.ColumnUnits = ColumnUnits;
CardTable.ColumnUnit = ColumnUnit;
CardTable.SubHeader.ColumnUnits = ColumnUnits;

export { CardTable };
